/*******************************************************************************
MINIMIZE A NEWS UPDATE
Shrinks a news update down to just its headline.
*******************************************************************************/

export default function minimizeUpdate(e) {
    const $newsUpdate = $(e.currentTarget);

    // We need links inside the news update to continue to work
    if (e.target.className === 'news-update__top') {
        $newsUpdate.removeClass('was-user-expanded').addClass('is-compact');
    }
}
